//REDUX
import { postData } from '@redux/slices/functionals/request/requestActions';
import { filterObjectByInterface } from '@services/utils/helper.utils';
import { CreateKpiDefinitionDto } from '@ts/ui-models';

import { CCreateKPI } from '@ts/ui-models';


export const postKPIDefinition = (dispatch, kpiObj: CCreateKPI) => {
    const template: Partial<CreateKpiDefinitionDto> = {
        name: '',
        resultOptions: undefined,
        scheduleConfig: {
            enabled: false,
            schedule: '',
            dataPeriod: {
                type: '',
                params: {
                    start: '',
                    end: '',
                }
            },
            timezone: ''
        },
        statisticsToCalculate: undefined,
        kpiOperationId: '',
        kpiOperation: undefined,
        rulesetId: '',
        ruleset: {
            id: '',
            name: ''
        }

    };

    const KPIfilteredObjectByInterface = filterObjectByInterface<CreateKpiDefinitionDto>(kpiObj, template)
    return dispatch(
        postData({
            url: '/api/v2/kpi/new',
            dataBody: { ...KPIfilteredObjectByInterface },
        })
    );


};
